import { Typography, Box } from '@mui/material';
import { DATE_FORMAT } from '@ui-framework/index';

import dayjs from 'dayjs';

function splitCamelCaseAndCapitalize(str) {
  if (!str) return '';
  const withSpaces = str.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

function createdBy(original) {
  return `${original?.createdBy?.firstName || ''} ${original?.createdBy?.lastName || ''}`;
}

function auditData(original) {
  return original.auditData.map(row => (
    <Box key={row.newRecordVersion} mb={1}>
      <Typography variant="body2">
        <b>{splitCamelCaseAndCapitalize(row.field)}</b>:&nbsp;
        {row.oldValue !== undefined && row.oldDisplayValue === undefined && (
          <Box component="span" sx={{ color: 'text.secondary', mr: '5px' }}>
            Old: {String(row.oldValue) || '-'}{' '}
          </Box>
        )}
        {row.oldDisplayValue !== undefined && (
          <Box component="span" sx={{ color: 'text.secondary', mr: '5px' }}>
            Old: {row.oldDisplayValue || '-'}{' '}
          </Box>
        )}
        {row.newValue !== undefined && row.newDisplayValue === undefined && (
          <Box component="span" sx={{ color: 'primary.main', mr: '5px' }}>
            New: {String(row.newValue) || '-'}{' '}
          </Box>
        )}
        {row.newDisplayValue !== undefined && (
          <Box component="span" sx={{ color: 'primary.main' }}>
            New: {row.newDisplayValue || '-'}
          </Box>
        )}
      </Typography>
    </Box>
  ));
}

function createdDateTime(original) {
  return original?.createdDateTime
    ? dayjs(original?.createdDateTime).format(DATE_FORMAT.LONG_DATE)
    : '';
}

export { auditData, createdBy, createdDateTime };
